import { Link, type LinkProps } from "react-router-dom";
import { markGuestBrowse } from "@/lib/guestBrowsing";

/**
 * The marketing homepage's internal link primitive.
 *
 * Every in-app link on "/" goes through here so that the ones pointing at
 * /browse record guest-browse intent before navigating, without each call site
 * repeating the logic. Links to anywhere else behave as a plain <Link>.
 *
 * Reachability does not depend on this — `Browse` no longer bounces signed-out
 * visitors, so a bare /browse URL (a shared link, a bookmark, a crawl) works on
 * its own. This only marks the intent. See src/lib/guestBrowsing.ts.
 */
export function HomeLink({ to, onClick, children, ...rest }: LinkProps) {
  const goesToBrowse = typeof to === "string" && to.startsWith("/browse");

  return (
    <Link
      to={to}
      onClick={(e) => {
        if (goesToBrowse) markGuestBrowse();
        onClick?.(e);
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}
